const CDN_CONFIG = {
  packageName: 'eyeai-avatar-component',
};

export async function initializeEyeaiAvatarComponent(assetsBaseUrl: string) {

   new Promise((resolve, reject) => {
    const fullUrl = `${assetsBaseUrl}/${CDN_CONFIG.packageName}/eyeai-avatar-component.esm.js`;
    const script = document.createElement('script');
    script.type = 'module';
    script.src = fullUrl;

    script.onload = async () => {
      try {
        await new Promise(resolve => setTimeout(resolve, 100));

        const dynamicImport = new Function('url', 'return import(url)');
        const module = await dynamicImport(fullUrl);

        if (module) {
          resolve(module);
        } else {
          const error = new Error('defineCustomElements not found in CDN module');
          console.error('CDN module loaded but defineCustomElements not found:', module);
          reject(error);
        }
      } catch (error: any) {
        console.error('Error loading Fip Agent from CDN:', error.message);
        reject(error.message);
      }
    };

    script.onerror = () => {
      const error = new Error(`Failed to load script from CDN: ${fullUrl}`);
      console.error('Script load error:', error);
      reject(error);
    };

    document.head.appendChild(script);
  });
}

